export default () => `#${parseInt(Math.random() * 2**64).toString(16)}`

